/** @format */

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  getInstanceList: '/monitor/?Action=DescribeMonitorInstances&Version=2021-01-01', // 获取实例列表
  getChildType: '/monitor/?Action=DescribeChildTypes&Version=2021-01-01', // 获取childType
  // eslint-disable-next-line max-len
  getChildInstance: '/monitor/?Action=DescribeMonitorSubInstances&Version=2021-01-01', // 获取childType实例列表
  // eslint-disable-next-line max-len
  getInstanceMetrics: '/monitor/?Action=DescribeInstanceMetrics&Version=2021-01-01', // 获取实例的监控列表(监控详情)
  // eslint-disable-next-line max-len
  getInstancePolicy: '/monitor/?Action=DescribeAlarmPolicyListByResource&Version=2021-01-01', // 获取实例的策略list(策略详情)
  // eslint-disable-next-line max-len
  getDescribeScreen: '/monitor/?Action=DescribeScreen&Version=2021-01-01', // 获取实例的监控列表(监控图)
  getChartData: '/monitorapi/v2/dashboard/querydata?parallel',
  getMetricsData: '/monitor/?Action=DescribeMetricsData&Version=2022-01-01', // 获取监控指标数据（专线网关）
  // eslint-disable-next-line max-len
  queryAggregateInstace: '/monitor/?Action=DescribeAggregateInstance&Version=2021-01-01', // 获取聚合实例详情
  // eslint-disable-next-line max-len
  getInstanceMetricTags: '/monitor/?Action=DescribeInstanceMetricTags&Version=2021-01-01', // 获取监控项Tags
  createAggregateInstance: '/monitorapi/host/createAggregateInstance', // 创建聚合实例
  modifyAggregateInstance: '/monitorapi/host/modifyAggregateInstance', // 修改聚合实例
  getUFMClusters: '/monitor/?Action=ListClusters&Version=2022-01-01', // UFM网络拓扑-数据源
  getUFMNodes: '/monitor/?Action=ListSystems&Version=2022-01-01', // UFM网络拓扑-设备
  getUFMEdges: '/monitor/?Action=ListLinks&Version=2022-01-01', // UFM网络拓扑-链路
  getUFMPort: '/monitor/?Action=ListPorts&Version=2022-01-01', // UFM网络拓扑-端口
  getUFMMetrics: '/monitor/?Action=ListLinkMetrics&Version=2022-01-01', // UFM网络拓扑-监控项
  // eslint-disable-next-line max-len
  getUFMAnalysisConfig: '/monitor/?Action=DescribeLinkAnalysis&Version=2022-01-01', // UFM网络拓扑-获取链路分析
  // eslint-disable-next-line max-len
  setUFMAnalysisConfig: '/monitor/?Action=PutLinkAnalysis&Version=2022-01-01', // UFM网络拓扑-设置链路分析
  getNCEClusters: '/monitor/?Action=ListNCEClusters&Version=2024-01-01', // NCE网络拓扑-数据源
  getNCEFabrics: '/monitor/?Action=ListNCEFabrics&Version=2024-01-01', // NCE网络拓扑-Fabric
  getNCENodes: '/monitor/?Action=ListNCENetworkElements&Version=2024-01-01', // NCE网络拓扑-设备
  getNCEEdges: '/monitor/?Action=ListNCELinks&Version=2024-01-01', // NCE网络拓扑-链路
  getNCEPort: '/monitor/?Action=ListNCEPorts&Version=2024-01-01', // NCE网络拓扑-设备端口
  // eslint-disable-next-line max-len
  getNCEPortIndicator: '/monitor/?Action=DescribeNCEPortIndicator&Version=2024-01-01', // NCE网络拓扑-设备端口指标信息
  // 收藏
  getFavorites: '/monitor/?Action=ListFavoritesMenu&Version=2022-01-01',
  setFavorites: '/monitor/?Action=PutFavoritesMenu&Version=2022-01-01',
  delFavorites: '/monitor/?Action=DeleteFavoritesMenu&Version=2022-01-01'
}
